module.exports = __webpack_public_path__ + "img/filosofia.0c2f9a3d.svg";